export enum CurrencyType {
    None,
    UAH,
    USD,
    EUR,
    PLN,
    CZK
}
